declare namespace $ {

	type $shm_hitalama_map_widget_entity_form_view__form_shm_hitalama_map_widget_float_form_edit_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_edit['form'] >
		,
		ReturnType< $shm_hitalama_map_widget_entity_form_view['form'] >
	>
	type $shm_hitalama_map_widget_entity_form_view__map_shm_hitalama_map_widget_float_form_edit_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_edit['map'] >
		,
		ReturnType< $shm_hitalama_map_widget_entity_form_view['map'] >
	>
	type $shm_hitalama_map_widget_entity_form_view__buttons_shm_hitalama_map_widget_float_form_edit_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_entity_form_view['buttons'] >
	>
	export class $shm_hitalama_map_widget_float_form_edit extends $shm_hitalama_map_widget_float {
		form( ): $shm_hitalama_map_widget_entity_form
		map( ): $shm_hitalama_map
		Form( ): $shm_hitalama_map_widget_entity_form_view
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=edit.view.tree.d.ts.map